<script setup>
import ShowMapButton from './ShowMapButton.vue';
import ShowListButton from './ShowListButton.vue';
import { ViewType } from './map-constants';

defineProps({
  currentView: {
    type: String,
    required: true,
  },
});

const emit = defineEmits([ 'set-view' ]);
</script>

<template>
  <div class="sticky-tabs">
    <!-- @TODO: Add share button, @see https://bureaux-a-partager.atlassian.net/browse/MATCH-8196 -->

    <ShowListButton
      v-if="currentView === ViewType.MAP"
      @click="emit('set-view', ViewType.LIST)"
    />
    <ShowMapButton
      v-else
      @click="emit('set-view', ViewType.MAP)"
    />
  </div>
</template>
